import { StatusReadyToReviewIssuesFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const issuesDescription = (issues: StatusReadyToReviewIssuesFragment['issues']) => {
  const missingFieldsCount = issues.filter((issue) => issue.type === 'missingfield').length
  const invalidValuesCount = issues.filter((issue) => issue.type === 'invalidvalue').length

  return (
    i18n.tp('expenses_v2.expense.status.ready_to_review_issues.description_prefix', {
      count: issues.length,
    }) +
    [
      missingFieldsCount > 0
        ? i18n.tp('expenses_v2.expense.status.ready_to_review_issues.missing_required', {
            count: missingFieldsCount,
          })
        : null,
      invalidValuesCount > 0
        ? i18n.tp('expenses_v2.expense.status.ready_to_review_issues.invalid_value', {
            count: invalidValuesCount,
          })
        : null,
    ]
      .filter((x) => !!x) //remove nulls
      .join(', ')
  )
}
